export default class LoadingSubmitButton {
    constructor() {
        this.isSubmitted = false;
        this.loadingForms = document.querySelectorAll("form");

        if (this.loadingForms && this.loadingForms.length > 0) {
            this.loadingForms.forEach((loadingForm) => {
                loadingForm.addEventListener("submit", this.showLoading);
            });
        }
    }

    showLoading(event) {
        if (this.isSubmitted) {
            event.preventDefault();

            return;
        }

        const isLoadingBtns = event.target.querySelectorAll("[type='submit'].is-loading");
        if (isLoadingBtns && isLoadingBtns.length > 0) {
            isLoadingBtns.forEach((isLoadingBtn) => {
                const loader = document.createElement("div");
                loader.className = "btn-loader";

                isLoadingBtn.innerHTML = "";
                isLoadingBtn.appendChild(loader);
            });
            this.isSubmitted = true;
        }
    }
}
